export default {
  // 页面标题
  'new_users_retention_by_timezone_title': '新进留存(分时区)',
  // 页面副标题
  'new_users_retention_by_timezone_sub_title_country': "本页展示按国家当地时区口径计算的数据.",
  'new_users_retention_by_timezone_sub_title_zone': "本页展示按区服当地时区口径计算的数据.",

  // 热力图
  "new_users_retention_by_timezone_Retention_of_New_Users": "留存新用户",
  "new_users_retention_by_timezone_column_Register": "注册",
  "new_users_retention_by_timezone_column_Timezone": "时区",

  'new_users_retention_by_timezone_sub_title': "此页面显示为按国家当地时区分别计算的数据。T日期的数据(比如，12月1日)，会在T+2（12月3日）早上9点（UTC +8）更新。",
}
